import { FacilityContextProvider } from '@/contexts/facility-context/context';
import { getCurrentUserRoles } from '@/hooks/use-current-user';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { RoleName } from '../../../../backend/src/types.generated';

function RouteComponent() {
	return (
		<FacilityContextProvider>
			<Outlet />
		</FacilityContextProvider>
	);
}

export const Route = createFileRoute('/facility')({
	component: RouteComponent,
	beforeLoad: async ({ context, location }) => {
		const roles = await getCurrentUserRoles(context.apolloClient);

		if (!roles?.some((role) => role.name === RoleName.Facility)) {
			if (roles?.some((role) => role.name === RoleName.User)) {
				throw redirect({
					to: '/home',
				});
			}

			throw redirect({
				to: '/auth/login',
				search: {
					redirect: location.href,
				},
			});
		}

		if (location.href === '/facility') {
			throw redirect({
				to: '/facility/home',
			});
		}
	},
});
